var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash3-fill",
    d: "M11,1.5v1h3.5a.5.5,0,0,1,0,1h-.538l-.853,10.66A2,2,0,0,1,11.115,16H4.885a2,2,0,0,1-1.994-1.84L2.038,3.5H1.5a.5.5,0,0,1,0-1H5v-1A1.5,1.5,0,0,1,6.5,0h3A1.5,1.5,0,0,1,11,1.5Zm-5,0v1h4v-1A.5.5,0,0,0,9.5,1h-3a.5.5,0,0,0-.5.5ZM4.5,5.029l.5,8.5a.5.5,0,1,0,1-.06l-.5-8.5a.5.5,0,1,0-1,.06ZM11.03,4.5a.5.5,0,0,0-.528.47l-.5,8.5a.5.5,0,0,0,1,.058l.5-8.5a.5.5,0,0,0-.47-.528ZM8,4.5a.5.5,0,0,0-.5.5v8.5a.5.5,0,0,0,1,0V5A.5.5,0,0,0,8,4.5Z",
    transform: "translate(-1)",
    fill: "#e88181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFile);
export default __webpack_public_path__ + "static/media/deleteFile.562068fd41b47af44fe874737eca2656.svg";
export { ForwardRef as ReactComponent };